// src/components/sections/HeroSection.jsx
import React from 'react';
import '../../styles/sections/HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      {/* Background Image */}
      <div className="hero-background">
        <div 
          className="hero-bg-image"
          style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')",
          }}
        >
          <div className="hero-bg-overlay"></div>
        </div>
      </div>

      {/* Content */}
      <div className="hero-content">
        <div className="hero-badge">🎉 Cyber Monday Sale: 35% off for 12 months</div>
        
        <h1 className="hero-title">
          Cyber Monday savings that <span className="hero-highlight">fuel growth</span>
        </h1>
        
        <p className="hero-description">
          Set the foundation for lasting growth this season with the platform trusted by top Amazon and TikTok sellers.
        </p>
        
        <div className="hero-buttons">
          <button className="primary-button">Claim your 35% discount</button>
          <button className="secondary-button">Sign up free</button>
        </div>
        
        {/* Marketplace Logos */}
        <div className="marketplace-logos">
          <div className="marketplace-item">
            <span className="marketplace-icon">🛍️</span>
            <span className="marketplace-name">Amazon</span>
          </div>
          <div className="marketplace-item">
            <span className="marketplace-icon">🏪</span>
            <span className="marketplace-name">Walmart</span>
          </div>
          <div className="marketplace-item">
            <span className="marketplace-icon">🎵</span>
            <span className="marketplace-name">TikTok Shop</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;